import React from "react";
import GuideElements from "../components/bookYourGuide/guideProfile/GuideElements";
import { useLocation } from "react-router-dom";
import GoToTop from "../components/GotoTop";
import Programs from "../components/bookYourGuide/guideProfile/programs/Programs";
import Reviews from "../components/bookYourGuide/guideProfile/reviews/Reviews";

import guideDataEN from "../i18n/translations/GuideData/GuideDataEn";
import guideDataAr from "../i18n/translations/GuideData/GuideDataAr";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

function GuideProfile() {
	
	const { t, i18n } = useTranslation();
	const currentLanguage = i18n.language;

	// console.log(guideData);

	let { state } = useLocation();
	const {
		idGuide,
		name,
		image,
		imgCover,
		province,
		rate,
		noOfReviews,
		UsersReviews,
	} = state ?? {};

	return (
		<div>
			<GoToTop />
			<GuideElements
				idGuide={idGuide}
				name={name}
				image={image}
				imgCover={imgCover}
				province={province}
				rate={rate}
				noOfReviews={noOfReviews}
			/>
			<Programs/>
			<Reviews/>
		</div>
	);
}

export default GuideProfile;
